<template>
    <div class="turn-page">
        <div class="turn-page_btn">
            <el-button :disabled="jurgePage" class="turn-page-btn" @click="turnPageEvent('last')">上一页</el-button>
            <span>{{pages}}</span>
            <el-button :disabled="nextDisable" class="turn-page-btn" @click="turnPageEvent('next')">下一页</el-button>
        </div>
        <div class="turn-page_text" v-show="textShow">{{turnText}}</div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            pages: 1,
            lastDisable: true,
            nextDisable: false,
            turnText: '',
            textShow: false,
            direction: ''
        }
    },
    props: [
        'tag'
    ],
    computed: {
        jurgePage() {
            if (this.pages == 1) {
                return true;
            }
        }
    },
    methods: {
        // 翻页事件
        turnPageEvent(flag) {
            this.direction = flag;
            if (flag == 'last') {
                this.$emit('turnPage', flag, this, this.tag);
            } else if (flag == 'next') {
                this.$emit('turnPage', flag, this, this.tag);
            }
        },

        // 页数改变事件
        pageChangeEvent(flag) {
            if (flag == 'next') {
                this.pages ++;
                this.lastDisable = false;
            } else if (flag == 'last') {
                this.pages --;
                if (this.pages > 1) {
                    this.lastDisable = false;
                } else if (this.pages <= 1) {
                    this.pages = 1;
                    this.lastDisable = true;
                }
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.turn-page {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);

    .turn-page-btn {
        display: inline-block;
        padding: 5px 10px;
        background-color: #333;
        font-size: 12px;
        border-color: #333;
        border-radius: 0;
    }
    
    .turn-page_text {
        text-align: center;
        padding: 10px;
    }
}
</style>
